import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { getBotConfig, getUserId } from '../../redux'
import operations from '../../redux/operations'

function ButtonAction({
  button,
  circular,
  sendQuickReply,
  botConfig,
  userId,
}) {
  if (button.type === 'openUrl' || button.type === 'blank') {
    return (
      <Button
        basic
        as="a"
        color="blabla"
        target="_blank"
        href={button.value}
        content={button.title}
      />
    )
  } else if (button.type === 'postBack') {
    const value = button.value
    return (
      <Button
        basic
        color="blabla"
        onClick={(e, data) => sendQuickReply(botConfig, value, data, userId)}
        content={button.title}
      />
    )
  } else {
    return (null)
  }
}

ButtonAction.propTypes = {
  button: PropTypes.object.isRequired,
  circular: PropTypes.bool,
  sendQuickReply: PropTypes.func.isRequired,
  botConfig: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  botConfig: getBotConfig(state),
  userId: getUserId(state),
});

export default connect(
  mapStateToProps,
  operations,
)(ButtonAction)

// export default ButtonAction



// WEBPACK FOOTER //
// ./src/views/components/Button.js